export default "__VITE_ASSET__DEnivejo__"